module.exports = __webpack_public_path__ + "img/handraw_aspect visuel.022ba954.svg";